var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.show),expression:"show"}],staticClass:"loadMessage",attrs:{"element-loading-spinner":"el-icon-loading","element-loading-text":"正在处理中..."}})
}
var staticRenderFns = []

export { render, staticRenderFns }